var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: {
                data: _vm.tableData,
                option: _vm.tableOption,
                page: _vm.page,
                "table-loading": _vm.tableLoading,
              },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "search-change": _vm.searchChange,
                "refresh-change": _vm.refreshChange,
                "size-change": _vm.sizeChange,
                "current-change": _vm.currentChange,
                "row-update": _vm.handleUpdate,
                "row-save": _vm.handleSave,
                "row-del": _vm.rowDel,
              },
              scopedSlots: _vm._u([
                {
                  key: "menuBtn",
                  fn: function (scope) {
                    return [
                      _vm.permissions.act_leavebill_edit && scope.row.state == 0
                        ? _c(
                            "el-dropdown-item",
                            {
                              attrs: { divided: "" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.handleSubmit(
                                    scope.row,
                                    scope.index
                                  )
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t提交\n\t\t\t\t")]
                          )
                        : _vm._e(),
                      _vm.permissions.act_leavebill_edit
                        ? _c(
                            "el-dropdown-item",
                            {
                              attrs: { divided: "" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.handleEdit(scope.row, scope.index)
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t编辑\n\t\t\t\t")]
                          )
                        : _vm._e(),
                      _vm.permissions.act_leavebill_del
                        ? _c(
                            "el-dropdown-item",
                            {
                              attrs: { divided: "" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.handleDel(scope.row, "suspend")
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t删除\n\t\t\t\t")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "menuLeft" },
                [
                  _vm.permissions.act_leavebill_add
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新 增")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }